import { IonRouterOutlet } from '@ionic/react';
import { Redirect, Route } from 'react-router';

import { ROUTES_PATH } from '@/constants';
import { ActualizaDatosSS } from '@/pages/ActualizaDatosSS/ActualizaDatosSS';
import { AltaClavePin } from '@/pages/AltaClavePin/AltaClavePin';
import Contact from '@/pages/Contact/Contact';
import Faq from '@/pages/Faq/Faq';
import Help from '@/pages/Help/Help';
import AllArticles from '@/pages/Learning/AllArticles/AllArticles';
import AllResourcesMobile from '@/pages/Learning/AllResourcesMobile/AllResourcesMobile';
import AllWebinars from '@/pages/Learning/AllWebinars/AllWebinars';
import ArticleDetail from '@/pages/Learning/Article/ArticleDetail';
import Learning from '@/pages/Learning/Learning';
import WebinarDetail from '@/pages/Learning/Webinar/WebinarDetail';
import ChangePassword from '@/pages/Login/ChangePassword/ChangePassword';
import Notifications from '@/pages/Notifications/Notifications';
import OperationDetail from '@/pages/Operations/OperationDetail/OperationDetail';
import OperationRefund from '@/pages/Operations/OperationRefund/OperationRefund';
import OperationsDashboard from '@/pages/Operations/OperationsDashboard/OperationsDashboard';
import Plugin from '@/pages/Plugin/Plugin';
import { PrivacyPolicy } from '@/pages/PrivacyPolicy/PrivacyPolicy';
import Configuration from '@/pages/Profile/Configuration/Configuration';
import Documents from '@/pages/Profile/Documents/Documents';
import Profile from '@/pages/Profile/Profile';
import MonthSettlements from '@/pages/Reporting/MonthSettlements/MonthSettlements';
import Reporting from '@/pages/Reporting/Reporting';
import CurrentSettlement from '@/pages/Reporting/SettlementDetail/SettlementDetail';
import TermsUse from '@/pages/TermsUse/TermsUse';

export default function LoggedRoutes() {
  return (
    <IonRouterOutlet>
      <Route exact path={ROUTES_PATH.OPERATION_DASHBOARD}>
        <OperationsDashboard />
      </Route>
      <Route exact path={ROUTES_PATH.OPERATION_DASHBOARD_DETAIL}>
        <OperationDetail />
      </Route>
      <Route exact path={ROUTES_PATH.OPERATION_REFUND}>
        <OperationRefund />
      </Route>
      <Route exact path={ROUTES_PATH.REPORTING}>
        <Reporting />
      </Route>
      <Route exact path={`${ROUTES_PATH.MONTH_SETTLEMENT}/:date`}>
        <MonthSettlements />
      </Route>
      <Route exact path={`${ROUTES_PATH.SETTLEMENT_DETAIL}/:id`}>
        <CurrentSettlement />
      </Route>
      <Route exact path={ROUTES_PATH.LEARNING}>
        <Learning />
      </Route>
      <Route exact path={ROUTES_PATH.HELP}>
        <Help />
      </Route>
      <Route exact path={ROUTES_PATH.FAQ}>
        <Faq />
      </Route>
      <Route exact path={ROUTES_PATH.CONTACT}>
        <Contact />
      </Route>
      <Route exact path={ROUTES_PATH.PROFILE}>
        <Profile />
      </Route>
      <Route exact path={ROUTES_PATH.CONFIGURATION}>
        <Configuration />
      </Route>
      <Route exact path={ROUTES_PATH.NOTIFICATIONS}>
        <Notifications />
      </Route>
      <Route exact path={ROUTES_PATH.DOCUMENTS}>
        <Documents />
      </Route>
      <Route exact path={ROUTES_PATH.ALL_RESOURCES_MOBILE}>
        <AllResourcesMobile />
      </Route>
      <Route exact path={ROUTES_PATH.ARTICLE_ALL}>
        <AllArticles />
      </Route>
      <Route exact path={`${ROUTES_PATH.ARTICLE_DETAIL}/:id`}>
        <ArticleDetail />
      </Route>
      <Route exact path={ROUTES_PATH.WEBINAR_ALL}>
        <AllWebinars />
      </Route>
      <Route exact path={`${ROUTES_PATH.WEBINAR_DETAIL}/:id`}>
        <WebinarDetail />
      </Route>
      <Route exact path={ROUTES_PATH.LOGIN_CHANGE_PASSWORD}>
        <ChangePassword />
      </Route>
      <Route exact path={ROUTES_PATH.PLUGIN}>
        <Plugin />
      </Route>
      <Route exact path={ROUTES_PATH.TERMS_USE}>
        <TermsUse />
      </Route>
      <Route exact path={ROUTES_PATH.PRIVACY_POLICY}>
        <PrivacyPolicy />
      </Route>
      <Route exact path={ROUTES_PATH.ACTUALIZA_DATOS_SS}>
        <ActualizaDatosSS />
      </Route>
      <Route exact path={ROUTES_PATH.ALTA_CLAVE_PIN}>
        <AltaClavePin />
      </Route>
      <Redirect to={ROUTES_PATH.OPERATION_DASHBOARD} />
    </IonRouterOutlet>
  );
}
